import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  main: {
    padding: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    gap: "16px",
  },
  textContainer: {
    maxWidth: "500px",
  },
  icon: {
    height: "38px",
    fill: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
  },
  title: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
    letterSpacing: "0.15px",
    padding: "4px",
  },
  description: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "143%",
    letterSpacing: "0.15px",
  },
  eyeIcon: {
    width: "43.98px",
    height: "38px",
    flexShrink: 0,
    fill: "rgba(0, 0, 0, 0.56)",
  },
}));
